import { render, staticRenderFns } from "./rehabOrdersPage.html?vue&type=template&id=7c89d321&"
import script from "./rehabOrdersPage.vue?vue&type=script&lang=js&"
export * from "./rehabOrdersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports